"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropInteractionParams, DropLocation } from "@/components/waves/drops/Drop";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import WaveDropActions from "@/components/waves/drops/WaveDropActions";
import MemeWinnerHeader from "./MemeWinnerHeader";
import MemeWinnerDescription from "./MemeWinnerDescription";
import MemeWinnerArtistInfo from "./MemeWinnerArtistInfo";
import MemeDropTraits from "./MemeDropTraits";
import DropMobileMenuHandler from "@/components/waves/drops/DropMobileMenuHandler";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import { useDropContext } from "@/components/waves/drops/DropContext";
interface MemeWinnerDropProps {
  readonly drop: ExtendedDrop;
  readonly showReplyAndQuote: boolean;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuote: (param: DropInteractionParams) => void;
}
export default function MemeWinnerDrop(t0) {
  const $ = _c(49);
  const {
    drop,
    showReplyAndQuote,
    onReply,
    onQuote
  } = t0;
  const isMobile = useIsMobileDevice();
  const {
    location
  } = useDropContext();
  let t1;
  if ($[0] !== drop.metadata) {
    t1 = drop.metadata?.find(_temp)?.data_value ?? "Artwork Title";
    $[0] = drop.metadata;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const title = t1;
  let t2;
  if ($[2] !== drop.metadata) {
    t2 = drop.metadata?.find(_temp2)?.data_value ?? "This is an artwork submission for The Memes collection.";
    $[2] = drop.metadata;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const description = t2;
  let t3;
  if ($[4] !== drop.parts) {
    t3 = drop.parts.at(0)?.media?.at(0);
    $[4] = drop.parts;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const artworkMedia = t3;
  let t4;
  if ($[6] !== drop || $[7] !== onReply) {
    t4 = () => {
      onReply({
        drop,
        partId: drop.parts[0]?.part_id
      });
    };
    $[6] = drop;
    $[7] = onReply;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleOnReply = t4;
  let t5;
  if ($[9] !== drop || $[10] !== onQuote) {
    t5 = () => {
      onQuote({
        drop,
        partId: drop.parts[0]?.part_id
      });
    };
    $[9] = drop;
    $[10] = onQuote;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleOnQuote = t5;
  const t6 = `tw-w-full ${location === DropLocation.WAVE ? "tw-px-4 tw-py-1" : ""} tw-relative tw-group`;
  const t7 = `tw-rounded-xl tw-border tw-border-solid tw-border-transparent tw-border-l tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden ${location === DropLocation.WAVE ? "tw-bg-iron-900/80" : "tw-bg-iron-950"} ${"tw-shadow-[inset_1px_0_0_rgba(251,191,36,0.5),inset_0_1px_0_rgba(251,191,36,0.2),inset_-1px_0_0_rgba(251,191,36,0.2),inset_0_-1px_0_rgba(251,191,36,0.2)]"}`;
  let t8;
  if ($[12] !== drop) {
    t8 = <div className="tw-p-4 tw-pb-3 tw-border-b tw-border-solid tw-border-x-0 tw-border-t-0 tw-border-white/5 tw-bg-iron-900/30"><MemeWinnerArtistInfo drop={drop} /></div>;
    $[12] = drop;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== title) {
    t9 = <MemeWinnerHeader title={title} />;
    $[14] = title;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== description) {
    t10 = <MemeWinnerDescription description={description} />;
    $[16] = description;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = <div className="tw-px-4 tw-pt-4 tw-pb-4"><div className="tw-space-y-1">{t9}{t10}</div></div>;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== artworkMedia) {
    t12 = artworkMedia && <div className="tw-flex tw-justify-center tw-h-96 tw-mx-0.5 tw-bg-iron-950"><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} /></div>;
    $[21] = artworkMedia;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== drop) {
    t13 = <div className="tw-hidden lg:tw-block tw-p-4 tw-mt-4 tw-border-t tw-border-solid tw-border-x-0 tw-border-b-0 tw-border-white/5 tw-bg-iron-900/30"><MemeDropTraits drop={drop} /></div>;
    $[23] = drop;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t11 || $[26] !== t12 || $[27] !== t13 || $[28] !== t8) {
    t14 = <>{t8}{t11}{t12}{t13}</>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t8;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== drop || $[31] !== handleOnQuote || $[32] !== handleOnReply || $[33] !== showReplyAndQuote || $[34] !== t14) {
    t15 = <DropMobileMenuHandler drop={drop} showReplyAndQuote={showReplyAndQuote} onReply={handleOnReply} onQuote={handleOnQuote}>{t14}</DropMobileMenuHandler>;
    $[30] = drop;
    $[31] = handleOnQuote;
    $[32] = handleOnReply;
    $[33] = showReplyAndQuote;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== drop || $[37] !== handleOnQuote || $[38] !== handleOnReply || $[39] !== isMobile || $[40] !== showReplyAndQuote) {
    t16 = !isMobile && showReplyAndQuote && <div className="tw-absolute tw-right-4 tw-top-2"><WaveDropActions drop={drop} activePartIndex={0} onReply={handleOnReply} onQuote={handleOnQuote} /></div>;
    $[36] = drop;
    $[37] = handleOnQuote;
    $[38] = handleOnReply;
    $[39] = isMobile;
    $[40] = showReplyAndQuote;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t15 || $[43] !== t16 || $[44] !== t7) {
    t17 = <div className={t7}>{t15}{t16}</div>;
    $[42] = t15;
    $[43] = t16;
    $[44] = t7;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t17 || $[47] !== t6) {
    t18 = <div className="tw-w-full tw-mb-3"><div className={t6}>{t17}</div></div>;
    $[46] = t17;
    $[47] = t6;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  return t18;
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}
function _temp(m) {
  return m.data_key === "title";
}